import React, { useState, useEffect, useRef } from "react";
import "../styles/NavBar.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1200);
      if (window.innerWidth >= 1200) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  if (isSmallScreen) {
    return (
      <nav className="navbar" ref={menuRef}>
        <div className="popover-menu-container">
          <Link to="/" className="nav-logo-link" onClick={closeMenu}>
            <span className="nav-logo-text">Wish Upon a Playhouse</span>
          </Link>
          <FontAwesomeIcon
            icon={isMenuOpen ? faTimes : faBars}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="menuBars"
          />
          {isMenuOpen && (
            <div className="popover-menu">
              <Link to="/" onClick={closeMenu}>
                Home
              </Link>
              <Link to="/playhouses" onClick={closeMenu}>
                Playhouses
              </Link>
              <Link to="/playhouses/ranch" onClick={closeMenu}>
                Ranch
              </Link>
              <Link to="/playhouses/sweet-shoppe" onClick={closeMenu}>
                Sweet Shoppe
              </Link>
              <Link to="/playhouses/cottage" onClick={closeMenu}>
                Cottage
              </Link>
              <Link to="/playhouses/clubhouse" onClick={closeMenu}>
                Clubhouse
              </Link>
              <Link to="/gallery" onClick={closeMenu}>
                Gallery
              </Link>
              <Link to="/reviews" onClick={closeMenu}>
                Reviews
              </Link>
              <Link to="/about" onClick={closeMenu}>
                About
              </Link>
              <Link to="/playhouses/customize" onClick={closeMenu}>
                Customize
              </Link>
              <Link to="/playhouses/ordering" onClick={closeMenu}>
                Ordering
              </Link>
              <Link to="/playhouses/faq" onClick={closeMenu}>
                FAQ
              </Link>
              <Link to="/contact" onClick={closeMenu}>
                Contact
              </Link>
            </div>
          )}
        </div>
      </nav>
    );
  }

  return (
    <nav className="navbar">
      <div className="navbarContainer">
        <Link to="/" className="nav-logo-link">
          <span className="nav-logo-text">Wish Upon a Playhouse</span>
        </Link>
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li className="dropdown">
            <Link to="/playhouses">Playhouses</Link>
            <div className="dropdown-menu">
              <Link to="/playhouses/ranch" className="dropdown-link">
                Ranch
              </Link>
              <Link to="/playhouses/sweet-shoppe" className="dropdown-link">
                Sweet Shoppe
              </Link>
              <Link to="/playhouses/cottage" className="dropdown-link">
                Cottage
              </Link>
              <Link to="/playhouses/clubhouse" className="dropdown-link">
                Clubhouse
              </Link>
              <Link to="/playhouses/customize" className="dropdown-link">
                Customize
              </Link>
              <Link to="/playhouses/ordering" className="dropdown-link">
                Ordering
              </Link>
              <Link to="/playhouses/faq" className="dropdown-link">
                FAQ
              </Link>
            </div>
          </li>
          <li>
            <Link to="/gallery">Gallery</Link>
          </li>
          <li>
            <Link to="/reviews">Reviews</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
